import React from 'react'
import { Link as ReactRouterLink } from 'react-router-dom'

import { Box, Link, Flex } from '@chakra-ui/react'
import { Icon } from '@pnld/components-web'

import { IBreadcrumbsProps } from './types'

const Breadcrumbs: React.FC<IBreadcrumbsProps> = ({ items }) => {
  return (
    <Flex align="flex-start" gap={2} data-testid="breadcrumb">
      <Box>
        <Link as={ReactRouterLink} to="/" mr={2} color="#23415B">
          <Icon
            name="house-chimney"
            size="2xs"
            inverse
            data-testid="house-icon"
          />
        </Link>
        <Icon name="chevron-right" size="2xs" variant="neutral_light_1" />
      </Box>
      {items.map((item, index) => {
        const isLast = index === items.length - 1
        return (
          <Box key={`breadcrum-item-${index}`}>
            {isLast ? (
              <Box
                as="span"
                color="#23415B"
                fontSize="2xs"
                fontWeight="semibold"
                lineHeight="150%"
                aria-current="page"
                data-testid={`breadcrumb-${item.href.slice(1)}`}
              >
                {item.label}
              </Box>
            ) : (
              <Link
                as={ReactRouterLink}
                to={item.href || '#'}
                color="#23415B"
                fontSize="2xs"
                fontWeight="medium"
                lineHeight="150%"
                marginRight={2}
                data-testid={`breadcrumb-${item.href.slice(1)}`}
              >
                {item.label}
              </Link>
            )}
            {!isLast && (
              <Icon name="chevron-right" size="2xs" variant="neutral_light_1" />
            )}
          </Box>
        )
      })}
    </Flex>
  )
}

export default Breadcrumbs
